function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fillOpacity: 0.6,
  d: "M77.364 0l7.574 17.167h-4.225L79.69 14.7h-.02l-1.327-3.206h.022l-2.35-5.723-.019.054-.011-.029-4.065 11.36h.025l-.004.01h-3.974L74.615 0zm-20.12 3.453h-4.825V0h13.523v3.453h-4.824v13.714h-3.875zm-15.922 0h-4.824V0H50.02v3.453h-4.824v13.714h-3.874zM26.9 0l7.573 17.167H30.25l-.005-.012h.005l-3.095-7.477L25.55 5.77l-2.05 5.723h.008L22.361 14.7h-.01l-.875 2.467H17.5L24.15 0zM.28 0h10.148c2.25 0 4.074 1.332 4.074 3.872v9.422c0 2.54-1.825 3.873-4.074 3.873H.28zm3.874 13.714h5.733c.426 0 .65-.32.65-.839V4.243c0-.469-.224-.79-.65-.79H4.154z"
})));

var SvgBrand2Slime = function SvgBrand2Slime(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 85,
    height: 18,
    viewBox: "0 0 85 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBrand2Slime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brand2slime.a4b1f6b7.svg";
export { ForwardRef as ReactComponent };